/*
 * Module for the SPC Contract Status Details report criteria page
 */
rs.module("content/reports/criteria/spccontractstatusdetailscriteria",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, searchControlApi) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);
            var reportTypeRadioContainer = criteria.js(jsSelectors.reportTypeRadioContainer);
            var individualSection = criteria.js(jsSelectors.individualSection);
            var groupSection = criteria.js(jsSelectors.groupSection);
            var statusCodeSelect = groupSection.js(jsSelectors.statusCodeSelect);
            var planKeySelect = groupSection.js(jsSelectors.planKeySelect);
            var spcTypeSelect = groupSection.js(jsSelectors.spcTypeSelect);

            // Get Select helpers
            var statusCodeSelectHelper = selectHelper.getHelper(statusCodeSelect);
            var planKeySelectHelper = selectHelper.getHelper(planKeySelect);
            var spcTypeSelectHelper = selectHelper.getHelper(spcTypeSelect);

            // Setup event handlers
            reportTypeRadioContainer.find("input").on('click', () => toggleControls())

            // Show, hide, and clear controls based on the selected report type radio button.
            function toggleControls() {

                var isGroup = reportTypeRadioContainer.find("input:checked").val() == "true";

                // Swap visibility
                visibility.setVisible(individualSection, isGroup == false);
                visibility.setVisible(groupSection, isGroup == true);

                if (isGroup) {

                    // Clear individual section controls
                    searchControlApi.clear();
                }
                else { // Individual

                    // Clear group section controls.
                    statusCodeSelectHelper.setValue(null);
                    planKeySelectHelper.setValue(null);
                    spcTypeSelectHelper.setValue(null);
                }

                // Clear errors, we target the form to handle the entire page at once.
                // Since this only clears when changing the group type.
                $.js(jsSelectors.criteria).closest("form").clearErrors();
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);